module.exports = __webpack_public_path__ + "img/apple-store.ff0e51a4.svg";